import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
export class BubblePickProperties extends AbstractViewProperties {
}
;
export class FeatureFishFoodProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return !this.forceResponsive
            && this.panels && other.panels && this.panels.equals(other.panels)
            && this.bubble && other.bubble && this.bubble.equals(other.bubble)
            && this.pickPanel && other.pickPanel && this.pickPanel.equals(other.pickPanel)
            && this.panelValue && other.panelValue && this.panelValue.equals(other.panelValue)
            && this.helpText && other.helpText && this.helpText.equals(other.helpText)
            && this.helpTextBackground && other.helpTextBackground && this.helpTextBackground.equals(other.helpTextBackground)
            && this.equals(other);
    }
}
//# sourceMappingURL=FeatureFishFoodProperties.js.map